<nav class="col-auto bg-dark text-white offcanvas offcanvas-md offcanvas-start" tabindex="-1" id="sidebar">
  <div class="offcanvas-header d-md-none">
    <h5 class="offcanvas-title text-white">Menu</h5>
    <button type="button" class="btn-close btn-close-white text-reset" data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
  </div>
  <div class="offcanvas-body d-lg-block p-3">
    <ul class="nav flex-column">
      <li class="nav-item"><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                              class="nav-link text-white"><i class="bi bi-house-door me-2 text-primary"></i>
        Dashboard</a></li>
      <li class="nav-item"><a routerLink="/offers" routerLinkActive="active" class="nav-link text-white"><i
        class="bi bi-card-list me-2 text-primary"></i> Offers</a></li>
      <li class="nav-item"><a routerLink="/reports" routerLinkActive="active" class="nav-link text-white"><i
        class="bi bi-bar-chart me-2 text-primary"></i> Reports</a></li>
      <li class="nav-item"><a routerLink="/payments" routerLinkActive="active" class="nav-link text-white"><i
        class="bi bi-wallet2 me-2 text-primary"></i> Payments</a></li>
      <li class="nav-item"><a [ngClass]="getActiveMenuClass('/tools')"
                              class="nav-link dropdown-toggle d-flex align-items-center" data-bs-toggle="collapse"
                              href="#submenu-tools" role="button" aria-expanded="false" aria-controls="submenu-tools"><i
        class="bi bi-wrench text-primary me-2"></i><span>Tools</span></a>
        <div class="collapse" id="submenu-tools">
          <ul class="nav flex-column ms-3">
            <li class="nav-item"><a routerLink="/tools/postbacks" routerLinkActive="active" class="nav-link">Pixels/postbacks</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item"><a routerLink="/my-account" routerLinkActive="active" class="nav-link text-white active"><i
        class="bi bi-person-circle me-2 text-primary"></i> My Account</a></li>
    </ul>
    <hr class="text-white mt-4">
    <div class="affiliate-manager mt-4" *ngIf="accountManager">
      <h6 class="fw-bold text-white">Account Manager</h6>
      <div class="image">
        <img [ngSrc]="imageService.getImageUrl(accountManager.image, 128, 128)" alt="Manager" fill>
      </div>
      <p class="text-white small fw-bold">{{ accountManager }}</p>
      <p class="text-start small">
        <a *ngIf="getTelegram()" [href]="getTelegram()" target="_blank" class="text-white text-decoration-none"><i
          class="bi bi-telegram"></i> Telegram</a><br>
<!--        <a href="#" class="text-white text-decoration-none"><i class="bi bi-whatsapp"></i> Whatsapp</a><br>-->
        <a [href]="getEmail()" target="_blank" class="text-white text-decoration-none"><i class="bi bi-envelope"></i>
          Email</a><br>
        <a *ngIf="getTeams()" [href]="getTeams()" target="_blank" class="text-white text-decoration-none"><i
          class="bi bi-microsoft-teams"></i> Teams</a>
      </p>
    </div>
    <hr class="text-white mt-4">
    <p class="small opacity-75">
      <i class="bi bi-file-earmark-check me-2"></i><a href="#" class="text-white">Terms &amp; Conditions</a><br>
      <strong>Last Agreed Date:</strong><br>
      7/30/2024 3:20:40 PM</p>
    <hr class="text-white mt-4">
    <p class="small opacity-75">
      <i class="bi bi-file-earmark-text me-2"></i><a href="#" class="text-white opacity-75">Insertion Order</a>
    </p>
  </div>

  <div class="sticky-bottom">
    <div class="version">{{ getVersion() }}</div>
  </div>
</nav>
